export const common = {
  loading: "Loading content…",
  tryAgain: "Try again",
  requestId: "Request ID: {id}",
  closeDialog: "Close dialog",
  notifications: "Notifications",
  cancel: "Cancel",
  save: "Save",
  close: "Close",
  add: "Add",
  remove: "Remove",
  delete: "Delete",
  edit: "Edit",
  search: "Search",
  filter: "Filter",
  all: "All",
  none: "None",
  yes: "Yes",
  no: "No",
  status: "Status",
  actions: "Actions",
  created: "Created",
  updated: "Updated",
  notes: "Notes",
  optional: "Optional",
  loadingState: "Loading",
  empty: "No records",
  errorRetry: "Something went wrong.",
  signOut: "Sign out",
  brandName: "Grizzly Shop",
  brandSubtitle: "Industries operations",
  skipToContent: "Skip to main content",
  openMenu: "Open menu",
  closeMenu: "Close menu",
  switchLanguage: "Switch language",
  creating: "Creating…",
  saving: "Saving…",
  done: "Done",
  primaryContact: "Primary contact",
  primary: "Primary",
  unassigned: "Unassigned",
  fields: {
    name: "Name",
    title: "Title",
    phone: "Phone",
    email: "Email",
    notes: "Notes",
    label: "Label",
    kind: "Kind",
    city: "City",
    region: "Region",
    postalCode: "Postal code",
    country: "Country",
    street: "Street",
    line2: "Line 2",
    dueDate: "Due date",
    priority: "Priority",
    subject: "Subject",
    assignTo: "Assign to",
    type: "Type",
    description: "Description",
    quantity: "Quantity",
    unit: "Unit",
    unitPrice: "Unit price",
    amount: "Amount",
    date: "Date",
    reason: "Reason",
    method: "Method",
    reference: "Reference",
    category: "Category",
    customer: "Customer",
    invoice: "Invoice",
    status: "Status",
    search: "Search",
    from: "From",
    to: "To",
    code: "Code",
    sku: "SKU",
    rate: "Rate",
    sequence: "Sequence",
    workCenter: "Work centre",
    setupMinutes: "Setup minutes",
    runMinutes: "Run minutes per unit",
    material: "Material",
    plannedQuantity: "Planned quantity",
    total: "Total",
    balance: "Balance",
    paid: "Paid",
    due: "Due",
    count: "Count",
  },
  when: "When",
  notFound: {
    title: "Page not found",
    description: "The address you followed does not exist in the shop system.",
    back: "Back to dashboard",
  },
  placeholder: {
    plannedFor: "Planned for slice {slice}.",
    coming: "Coming in {slice}",
  },
};
